export const FOND_ACCUEIL_BOUTIQUECLUB = '/boutiqueclub/fonds/page-club.webp';
export const PREFIXE_FOND_STOCKAGE_GROUPE = 'storage:logos-groupes/';

export const FONDS_BOUTIQUECLUB_OFFICIELS = [
  ['basket', 'Basket', 'Basket', '/boutiqueclub/fonds/fond-basket.webp'],
  ['danse', 'Danse', 'Danse', '/boutiqueclub/fonds/fond-danse.webp'],
  ['football', 'Football', 'Football', '/boutiqueclub/fonds/fond-football.webp'],
  ['gymnastique', 'Gymnastique', 'Gymnastique', '/boutiqueclub/fonds/fond-gymnastique.webp'],
  ['handball', 'Handball', 'Handball', '/boutiqueclub/fonds/fond-handball.webp'],
  ['padel', 'Padel', 'Padel', '/boutiqueclub/fonds/fond-padel.webp'],
  ['petanque', 'Pétanque', 'Pétanque', '/boutiqueclub/fonds/fond-petanque.webp'],
  ['rugby', 'Rugby', 'Rugby', '/boutiqueclub/fonds/fond-rugby.webp'],
  ['sports-combat', 'Sports de combat', 'Sports de combat', '/boutiqueclub/fonds/fond-sports-combat.webp'],
  ['tennis', 'Tennis', 'Tennis', '/boutiqueclub/fonds/fond-tennis.webp'],
  ['volley', 'Volley', 'Volley', '/boutiqueclub/fonds/fond-volley.webp'],
].map(([id, libelle, sport, path], ordre) => ({ id:`officiel-${id}`, libelle, sport, path, actif:true, ordre, officiel:true }));

const texte = (valeur, longueur = 120) => String(valeur || '').trim().slice(0, longueur);

export function normaliserFondBoutiqueClub(fond, index = 0) {
  if (!fond || typeof fond !== 'object') return null;
  const path = texte(fond.path || fond.storage_path, 1000);
  if (!path || path.includes('\\') || [...path].some((caractere) => caractere.charCodeAt(0) < 32)) return null;
  return {
    id: texte(fond.id, 100) || `personnalise-${index}`,
    libelle: texte(fond.libelle || fond.nom, 100) || `Fond ${index + 1}`,
    sport: texte(fond.sport, 80) || 'Autre',
    path,
    actif: fond.actif !== false,
    ordre: Number.isFinite(Number(fond.ordre)) ? Number(fond.ordre) : index,
    officiel: false,
  };
}

export function fondsBoutiqueClub(configurationPublique = {}) {
  const ajouts = Array.isArray(configurationPublique?.fonds_graphiques)
    ? configurationPublique.fonds_graphiques.map(normaliserFondBoutiqueClub).filter(Boolean)
    : [];
  const surcharges = new Map(ajouts.map((fond) => [fond.id, fond]));
  const officiels = FONDS_BOUTIQUECLUB_OFFICIELS.map((fond) => ({ ...fond, ...(surcharges.get(fond.id) || {}), officiel:true }));
  const idsOfficiels = new Set(FONDS_BOUTIQUECLUB_OFFICIELS.map((fond) => fond.id));
  return [...officiels, ...ajouts.filter((fond) => !idsOfficiels.has(fond.id))]
    .sort((a, b) => Number(a.ordre) - Number(b.ordre) || a.libelle.localeCompare(b.libelle, 'fr'));
}

export function urlFondBoutiqueClub(path, urlsPhotos = {}) {
  if (!path) return '';
  return urlsPhotos[path] || (/^(?:https?:|data:|blob:|\/)/i.test(path) ? path : '');
}

export function cheminFondStockageGroupe(reference) {
  const valeur = texte(reference, 1000);
  if (!valeur.startsWith(PREFIXE_FOND_STOCKAGE_GROUPE)) return '';
  const chemin = valeur.slice(PREFIXE_FOND_STOCKAGE_GROUPE.length);
  if (!chemin.startsWith('fonds-boutique/') || chemin.includes('..') || chemin.includes('\\') || /[?#%]/.test(chemin)) return '';
  return chemin;
}

export function referenceFondStockageGroupe(chemin) {
  const valeur = texte(chemin, 900);
  if (!valeur.startsWith('fonds-boutique/') || valeur.includes('..') || valeur.includes('\\') || /[?#%]/.test(valeur)) return '';
  return `${PREFIXE_FOND_STOCKAGE_GROUPE}${valeur}`;
}

export async function signerFondStockageGroupe(clientSupabase, reference, duree = 3600) {
  const chemin = cheminFondStockageGroupe(reference);
  if (!clientSupabase || !chemin) return '';
  const { data, error } = await clientSupabase.storage.from('logos-groupes').createSignedUrl(chemin, duree);
  return error ? '' : (data?.signedUrl || '');
}

export function identifiantFondBoutiqueClub(libelle) {
  const base = texte(libelle, 80).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
    .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  return `personnalise-${base || Date.now()}`;
}
